import "./header.css";

function Header() {
  return <header>Navigator App</header>;
}

export default Header;
